import { Component, Input } from '@angular/core';
import { BaseInput } from '@app/shared/form/models';
import { prefixInput } from '@app/shared/form/utils';

@Component({
	template: ''
})
export class BaseInputComponent {
	@Input({ required: true }) control: BaseInput<any>;
	@Input({ transform: prefixInput }) controlId: string = '';
}
